import React, { useEffect, useMemo, useState } from "react";

import * as S from "./styles";

import Chart from "react-apexcharts";
import {
  CustomChartContainer,
  CustomChartHeader,
  CustomChartTitle,
} from "../styles";
import { CircularProgress } from "@mui/material";

var options = (data) => ({
  chart: {
    id: "chart-seguranca-conformidade",
    type: "bar",
    height: 350,
    toolbar: {
      show: false,
    },
    foreColor: "#000000",
  },
  colors: ["#4BBFEF"],
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 4,
      borderRadiusApplication: "end",
      borderRadiusWhenStacked: "last",
      dataLabels: {
        position: "top",
      },
    },
  },
  dataLabels: {
    enabled: true,
    style: {
      fontSize: "10px",
      fontFamily: "Inter, Helvetica, Arial, sans-serif",
      // fontWeight: 'bold',
      colors: ["#000"],
    },
    offsetY: -20,
  },
  tooltip: {
    enabled: false,
  },
  stroke: {
    show: true,
    width: 1,
  },
  grid: {
    show: true,
    borderColor: "#ccc",
    strokeDashArray: 0,
    position: "back",
    xaxis: {
      lines: { show: false },
    },
    yaxis: {
      lines: { show: true },
    },
  },
  xaxis: {
    categories: data?.xaxis?.categories,
    axisBorder: { show: false },
    axisTicks: { show: false },
  },
  yaxis: {
    labels: {
      style: {
        colors: ["#77838F"],
        fontSize: "12px",
        fontFamily: "Inter",
        fontWeight: 400,
      },
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    showForSingleSeries: true,
    colors: "#4BBFEF",
    horizontalAlign: "left",
    fontSize: "12px",
    fontFamily: "Poppins, Helvetica, Arial",
    fontWeight: 400,
    labels: {
      colors: "#000000",
      offsetX: 10,
    },
    markers: {
      size: 4,
      shape: undefined,
      strokeWidth: 0,
      fillColors: "#4BBFEF",
      customHTML: undefined,
      onClick: undefined,
      offsetX: -5,
      offsetY: 0,
    },
    offsetX: 0,
  },
});

const SegurancaConformidadeGraphic = ({ data, isLoadingData }) => {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: 643,
      }}
    >
      <CustomChartContainer>
        <CustomChartHeader>
          <CustomChartTitle>Segurança e Conformidade</CustomChartTitle>
        </CustomChartHeader>
        <S.ChartWrapper
          id="seguranca-conformidade-container"
          style={{ height: 426 }}
        >
          {isLoadingData ? (
            <CircularProgress style={{ color: "#F9922A" }} thickness={5} />
          ) : (
            <Chart
              options={options(data)}
              series={data.series}
              type="bar"
              width="97%"
            />
          )}
        </S.ChartWrapper>
      </CustomChartContainer>
    </div>
  );
};

export default SegurancaConformidadeGraphic;
